import kamala from '../../kamala'
import Button from './Button'

Button.install = function (Vue) {
  kamala(Vue)
  Vue.component(Button.name, Button)
}

export {
  Button,
}

export default Button
